import { HttpClient, type ApiResponse } from "../http";
import type { User } from "../types";

type MeCache = { result: ApiResponse<User>; ts: number } | null;
let _meCache: MeCache = null;
const ME_TTL = 30_000;

export class AuthService extends HttpClient {
  constructor() {
    super(process.env.NEXT_PUBLIC_API_URL!);
  }

  getGoogleAuthUrl(): string {
    return `${this.baseUrl}/api/auth/google`;
  }

  async me() {
    const now = Date.now();
    if (_meCache && now - _meCache.ts < ME_TTL) {
      return _meCache.result;
    }
    const result = await this.get<User>("/api/auth/me");
    if (!result.error) _meCache = { result: result as ApiResponse<User>, ts: now };
    return result;
  }

  invalidateMe() {
    _meCache = null;
  }

  async logout() {
    this.invalidateMe();
    return this.post<{ success: boolean }>("/api/auth/logout");
  }

  async sendOtp(email: string) {
    return this.post<{ success: boolean; message: string }>("/api/auth/otp/send", { email });
  }

  async verifyOtp(email: string, code: string) {
    this.invalidateMe();
    return this.post<{ success: boolean; user: User }>("/api/auth/otp/verify", { email, code });
  }
}
